import { render, staticRenderFns } from "./datepicker.vue?vue&type=template&id=2b48f2fe&scoped=true&"
import script from "./datepicker.vue?vue&type=script&lang=js&"
export * from "./datepicker.vue?vue&type=script&lang=js&"
import style0 from "./datepicker.vue?vue&type=style&index=0&id=2b48f2fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b48f2fe",
  null
  
)

export default component.exports